import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatButtonModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {
  @ViewChild('customSelect') customSelect: ElementRef | undefined;
  @ViewChild('selectBtn') selectBtn: ElementRef | undefined;
  @ViewChild('selectedValue') selectedValue: ElementRef | undefined;
  @ViewChild('optionsList') optionsList: ElementRef[] | undefined;
  
  public isAuthenticated: boolean = false;
  isScrolled = false;
  scroll = false;
  isMenuOpen = false;
  mobile?: boolean;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (typeof window !== 'undefined'){
        this.mobile = window.innerWidth < 935;
        window.addEventListener('resize', () => this.checkMobile());
      }
    }
  }
  
  checkMobile() {
    if (isPlatformBrowser(this.platformId)) {
      if (typeof window !== 'undefined'){
        this.mobile = window.innerWidth < 935;
      }
    }
  }

  selectedOpMenu: number | null = 3;
  
  showOptions: boolean = false;
  toggleOptions() {
    this.showOptions = !this.showOptions;
  }

  selectOption(option: string) {
    this.showOptions = false; 
  }

  acessaImoveis(info: string) {
    const queryParams =
      info === '2' ? { contrato: 'Compra', sortby: 'd_date' } : { contrato: 'Locação', sortby: 'd_date' };

      this.router.navigate(['/busca-avancada'], {
         queryParams,
         queryParamsHandling: 'replace'
      });

    this.fecharMenu();
   }
  
  acessaHome() {
    this.fecharMenu();
    this.router.navigate(['/']);
  }

  acessaSobre() {
    this.fecharMenu();
    this.router.navigate(['/sobre']);
  }

  acessarAreaCliente() {
    this.fecharMenu();
      window.open('https://cliente.portalunsoft.com.br/cancian', '_blank');
  }

  acessaTrabalhe() {
    this.fecharMenu();
    this.router.navigate(['/trabalhe-conosco']);
  }

 acessaContato() {
    this.fecharMenu();
    this.router.navigate(['/contato']);
  }

  acessaAnuncie() {
    this.fecharMenu();
    this.router.navigate(['/anuncie']);
  }

  private logaUsuario(): void {
    this.isAuthenticated = true;
  }
  
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (typeof window !== 'undefined'){
      this.isScrolled = window.scrollY > 0;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('.topic');
    if (!clickedInside) {
      this.dropdownActive = false;
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      if (typeof window !== 'undefined'){
        window.removeEventListener('resize', this.checkMobile.bind(this));
      }
    }
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  
  goToPage(route: string) {
    this.fecharMenu();
    this.router.navigateByUrl(route);
  }

  dropdownActive: boolean = false;
  toggleDropdown() {
    this.dropdownActive = !this.dropdownActive;
  }

  private fecharMenu() {
    setTimeout(() => {
      this.isMenuOpen = false;
    }, 50); 
  }
}